import { Editor, useEditorState } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { IconLabel } from '../../../IconLabel';

import classNames from 'classnames';
import classes from '../InlineTools.module.scss';

interface ItalicProps {
  editor: Editor;
}

export const Italic: FunctionComponent<ItalicProps> = ({ editor }) => {
  const { t } = useTranslation();

  const { isActive, canToggle } = useEditorState({
    editor,
    selector: ({ editor }) => ({
      isActive: editor.isActive('italic'),
      canToggle: editor.can().chain().focus().toggleItalic().run(),
    }),
  });

  return (
    <IconLabel
      iconId={'italic'}
      iconSize={16}
      ariaLabel={t('richTextEditor.tool-names-italic')}
      onClick={() => editor.chain().focus().toggleItalic().run()}
      disabled={!canToggle}
      className={classNames(classes['inline-tools__item'], {
        [classes['inline-tools__item--active']]: isActive,
        [classes['inline-tools__item--disabled']]: !canToggle,
      })}
    />
  );
};
